import { render, staticRenderFns } from "./FormAggregateInfo.vue?vue&type=template&id=edcb633a"
import script from "./FormAggregateInfo.vue?vue&type=script&lang=js"
export * from "./FormAggregateInfo.vue?vue&type=script&lang=js"
import style0 from "./FormAggregateInfo.vue?vue&type=style&index=0&id=edcb633a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports